import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/home';
import MyReward from '@/views/my-reward';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: '邀请有礼'
      }
    },
    {
      path: '/my-reward',
      name: 'MyReward',
      component: MyReward,
      meta: {
        title: '我的红包'
      }
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
});
